export const DEFAULT_TOUCH_SLOP = 15;

export const Direction = {
  RIGHT: 1,
  LEFT: 2,
  UP: 4,
  DOWN: 8,
};
